import FinalizeInvoicingSetup from './FinalizeInvoicingSetup/index';

export default FinalizeInvoicingSetup;
